import React from 'react'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/pro-light-svg-icons'
import { faCouch } from '@fortawesome/pro-light-svg-icons'
import { faExpandArrows } from '@fortawesome/pro-light-svg-icons'
import { faPencil } from '@fortawesome/pro-light-svg-icons'
import { faHomeHeart } from '@fortawesome/pro-light-svg-icons'
import { faHandsUsd } from '@fortawesome/pro-light-svg-icons'
import { faHeadphones } from '@fortawesome/pro-light-svg-icons'
import { faUsers } from '@fortawesome/pro-light-svg-icons'

import FlyersImage from '../../assets/flyers.png'
import NewspaperImage from '../../assets/newspaper.png'
import SignboardImage from '../../assets/signboard.jpg'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

const Marketing = () => (
  <div className={styles.root}>
    <ContentHolder>
      <h3 className={styles.title}>Marketing success</h3>

      <p>
        The success of our marketing campaigns is based on a number of important elements all working together
        seamlessly. Collaborating with leading professionals such as photographers, floorplanners and stylists, we
        create marketing collateral that showcases your home to perfection, strikes a chord with buyers and ensures it
        stands out in the marketplace. We take immense pride in our marketing, which is critical for attracting the
        right buyers and securing a premium price.
      </p>

      {/* Marketing Services */}
      <div className={styles.columnHolder}>
        <div className={styles.column}>
          <FontAwesomeIcon icon={faCamera} className={styles.columnIcon} />
          <span className={styles.columnTitle}>Photography</span>
          <div className={styles.columnBody}>
            We work with experienced photographers who specialise in the niche area of real estate photography, along
            with professional retouchers to complete the process. They know how to photograph your home in its best
            possible light, using dusk and night shoots and drone photography where necessary to make it visually
            impressive.
          </div>
        </div>

        <div className={styles.column}>
          <FontAwesomeIcon icon={faPencil} className={styles.columnIcon} />
          <span className={styles.columnTitle}>Copywriting</span>
          <div className={styles.columnBody}>
            Our experienced copywriters ensure our marketing sounds professional and highlights the most important sales
            features of your property. They know how to appeal to the right target market through clever, concise copy
            that complements the photography.
          </div>
        </div>

        <div className={styles.column}>
          <FontAwesomeIcon icon={faExpandArrows} className={styles.columnIcon} />
          <span className={styles.columnTitle}>Floorplans</span>
          <div className={styles.columnBody}>
            Our professional floorplans are an important element of the marketing mix, giving buyers a quick and
            accurate understanding of the layout and size of a property. It gives them a chance to understand how they
            might utilise the space.
          </div>
        </div>

        <div className={styles.column}>
          <FontAwesomeIcon icon={faCouch} className={styles.columnIcon} />
          <span className={styles.columnTitle}>Styling</span>
          <div className={styles.columnBody}>
            Where beneficial, we recommend professional styling, whether it&apos;s a full style for a vacant property or
            a semi-style where our stylists combine your existing furnishings with some designer touches. Our stylists
            know where to add important pieces, de-clutter, rearrange and reconfigure spaces to achieve maximum visual
            impact and functionality.
          </div>
        </div>
      </div>
      {/* End Marketing Services */}

      {/* Signboards */}
      <div className={styles.columnHolder}>
        <div className={classnames(styles.column, styles.left)}>
          <h3>Signboards</h3>

          <p>
            Our eye-catching signboards create plenty of on-site impact and provide both locals and passers by with a
            concise snapshot of all the important features of your property. Other signage - We can custom design any
            form of signage needed to give your property that extra impact, from banners to bespoke signboards for
            apartment buildings, developments or uniquely situated properties.
          </p>
        </div>

        <div className={styles.column}>
          <img alt="Signboards" src={SignboardImage} style={{ maxWidth: '100%' }} />
        </div>
      </div>
      {/* End Signboards */}

      {/* Direct Mail */}
      <div className={styles.columnHolder}>
        <div className={classnames(styles.column, styles.imageHolder)}>
          <img alt="Flyers" src={FlyersImage} />
        </div>

        <div className={classnames(styles.column, styles.left)}>
          <h3>Direct mail</h3>

          <p>
            It&apos;s vitally important to inform locals who know and love the area about your property&apos;s impending
            sale – they&apos;re very often your most important target market and direct mail is a great way to engage
            with the local community. We have a number of different options, including double-sided brochures and DL
            cards.
          </p>
        </div>
      </div>
      {/* End Direct Mail */}

      {/* Advertising */}
      <div className={styles.columnHolder}>
        <div className={classnames(styles.column, styles.left)}>
          <h3>Advertising</h3>

          <p>
            We have the capability to effectively target the broadest range of buyers through customised print media
            campaigns. After identifying the appropriate target market, the advertising mix may include local, daily,
            interstate and international publications as well as local Chinese newspapers.
          </p>
        </div>

        <div className={classnames(styles.column, styles.imageHolder, styles.imageRight)}>
          <img alt="Newspaper" src={NewspaperImage} />
        </div>
      </div>
      {/* End Advertising */}

      {/* Agent Services */}
      <div className={styles.columnHolder}>
        <div className={styles.column}>
          <FontAwesomeIcon icon={faHomeHeart} className={styles.columnIcon} />
          <span className={styles.columnTitle}>Open homes</span>
          <div className={styles.columnBody}>
            Our inspections allow us to collect valuable buyer information. We follow up diligently with everyone who
            comes through our open homes to ensure that we&apos;re effectively servicing our potential buyers, meeting
            all their needs and keeping them informed.
          </div>
        </div>

        <div className={styles.column}>
          <FontAwesomeIcon icon={faHandsUsd} className={styles.columnIcon} />
          <span className={styles.columnTitle}>Buyer alert</span>
          <div className={styles.columnBody}>
            Our buyer alert service keeps buyers up-to-date with properties matching their criteria as soon as we list
            them. These priority buyers also have the ability to view property before it&apos;s advertised to the
            general public, giving them the jump on the market and vendors the ability to capitalise on eager buyers and
            pent up demand.
          </div>
        </div>

        <div className={styles.column}>
          <FontAwesomeIcon icon={faHeadphones} className={styles.columnIcon} />
          <span className={styles.columnTitle}>Enquiry follow-up</span>
          <div className={styles.columnBody}>
            Whatever channel our property enquiries come through - whether it be via our website, other real estate
            portals, phone or open homes - we follow them up meticulously. Using our advanced database technology, we
            can then engage with these potential buyers, keep them up-to-date with new listings and make sure we&apos;re
            here if they need our advice.
          </div>
        </div>

        <div className={styles.column}>
          <FontAwesomeIcon icon={faUsers} className={styles.columnIcon} />
          <span className={styles.columnTitle}>Buyers database</span>
          <div className={styles.columnBody}>
            Our experienced Property Partners combine their considerable networks of buyers to create one centralised
            national database. Up-to-the-minute and high-tech, it provides an exceptionally targeted, cost-effective
            sales tools. We often sell property prior to marketing campaigns just on the strength of our network,
            effectively matching buyers to properties.
          </div>
        </div>
      </div>
      {/* End Agent Services */}
    </ContentHolder>
  </div>
)

export default Marketing
